import {
  projectStatusByCode,
  isLeader,
  isOwner,
  invoiceControlConfigByCode,
  isInvoiceRepriceActive,
} from 'entities';

import { CircleDollarIcon } from 'components/Icons';

import { registerProjectOption } from '../options';

import { ManageCostsModal } from './ManageCostsModal';

export default registerProjectOption({
  Icon: CircleDollarIcon,

  getLabel: (t) => t('manage-costs'),

  modal: 'MANAGE_COSTS',
  overlay: ManageCostsModal,

  shortcut: {
    key: 'M',
    triggerKey: ['ctrl'],
  },

  useOption: ({ loggedUser, project, openModal }) => {
    const isInvoiceUser = !!loggedUser.team.isInvoiceTeam;

    const { blocks } = projectStatusByCode[project.status];

    const checks = isInvoiceUser
      ? [
          isOwner(project.invoice, loggedUser),
          invoiceControlConfigByCode[project.invoice.status].canRequestReprice,
          project.addCountryRequest ? !project.addCountryRequest.finished : true,
        ]
      : [
          !blocks.fullBlock,
          !blocks.reprice,
          !isInvoiceRepriceActive(project),
          isOwner(project, loggedUser) ||
            (project.owner.team === loggedUser.team.id && isLeader(loggedUser)),
        ];

    const canManageCosts = checks.every(Boolean);

    return {
      isEnabled: canManageCosts,
      action: () => openModal('MANAGE_COSTS'),
    };
  },
});
